import { useQuery } from '@tanstack/react-query';
import { PlaylistApi } from './PlaylistApi';
import { PLAYLIST_QUERY_KEYS } from '@/lib/constants/playlist';
import { useAuth } from '@/features/auth/hooks/useAuth';
import type { PlaylistListResponse } from '@/lib/types/Playlist';

export interface UsePlaylistsResult {
  data: PlaylistListResponse | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function usePlaylists(options?: { enabled?: boolean }): UsePlaylistsResult {
  const { selectedCId } = useAuth();

  const query = useQuery({
    queryKey: PLAYLIST_QUERY_KEYS.all(selectedCId ?? 0),
    queryFn: () => PlaylistApi.getPlaylists(selectedCId!),
    enabled: (options?.enabled ?? true) && selectedCId != null,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
